module.exports = __webpack_public_path__ + "img/online_select.734fdee3.svg";